import styled from 'styled-components';

export const StyledSelect = styled.select`
  -webkit-appearance: none;
  appearance: none;

  border: 1px solid #0000001a;
  border-radius: 4px;

  width: 100%;
  height: 40px;
  box-sizing: border-box;
  padding: 0 8px;
  outline: none;

  option {
    padding: 4px;
    font-size: 12px;
    display: block;
  }

  &:focus {
    border: 1px solid ${props => props.theme.colors.primary}
  }

  &:disabled {
    cursor: not-allowed;
  }
`;


export const Label = styled.label`
  display: block;
  margin: 8px 0;
  font-size: 11px;
  line-height: 1.4;
`;